<div class="modelContainer">
    <div class="">
      <button (click)="onCloseClick()" type="button" class="close cancelBtn" aria-label="Close" mat-dialog-close>
        Close
      </button>
    </div>
    <div class="modelTitle heading2 alignCenter">      
      <span>Export Tenant</span>
    </div>   
    <div class="modelBody regularText">      
        <div class="container p-4 alignCenter" *ngIf="componentStatusList.length <= 0">
            No components associated with tenant  
        </div>
        <div class="container pl-4 pr-4 pb-4 pt-1">
            
            <div class="row mb-3">
                <div class="col-6 font-weight-bold">
                    Component 
                </div>
                <div class="col font-weight-bold">
                    Status
                </div>
            </div>
            <ng-container *ngFor="let component of componentStatusList">
                <hr class="mt-2 mb-2"/>
                <div class="row">
                    <div class="col-6">
                        {{component.componentName}}
                    </div>
                    <div class="col">
                        <div [ngClass]="{'bg-secondary': !component.exportStatus, 'bg-success' : component.exportStatus === tenantComponentStatus[2], 'bg-danger': component.exportStatus === tenantComponentStatus[3], 'bg-info' : component.exportStatus === tenantComponentStatus[1]}" class="compStatus text-white">
                            {{!component.exportStatus ? 'NOT STARTED' : component.exportStatus | uppercase }}
                        </div>
                    </div>
                </div>
            </ng-container>
            <hr class="mt-2 mb-2"/>
            <div class="row" *ngIf="exportStatusText">
                <div [ngClass]="{'text-success' : exportStatusText === tenantComponentStatus[2], 'text-danger': exportStatusText === tenantComponentStatus[3], 'text-info' : exportStatusText === tenantComponentStatus[1]}" class="col p-2 text-center">Tenant component export is {{exportStatusText}}</div>
            </div>
        </div>
        
        <div class="buttons">
            <button class="actionBtn secondaryBtn" tabindex="0" (click)="onCloseClick()">Close</button>
            <button class="actionBtn primaryBtn" [disabled]="exportBtnDisabled" tabindex="0" (click)="onExportClick()">Export</button>
            <div class="clear"></div>
        </div>
    </div>
  </div>
  